import React, { useEffect, useRef, useState } from "react";
import DataTableListing from "../DataTableListing/DataTableListing";
import BackButton from "../BackButton/BackButton";
import "./ViewDepartment.css";
import sort from "../../assets/images/sort.png";
import search_bar from "../../assets/images/search.svg";
import AccessRoleModal from "../AccessRoleModal/AccessRoleModal";
import { useSelector, useDispatch } from "react-redux";
import { truncate } from "../../utils/utlis";
import { resetDepartmentDetails, viewDepartmentAction } from "../../state/actions/departmentActions";
import { useAuth } from "../../features/auth/AuthContext";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';// Sample Data ──
import { Link, useNavigate, useLocation } from "react-router";
import EnrollmentResponsiveCards from "../../modules/admin/Dashboard/RecentEnrollment/EnrollmentResponsiveCards";
import SearchComponent from "../SearchComponent/SearchComponent";

// Advisors Page
function ViewDepartment({ navigateBack, subjectName, subjectId }) {
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const { token } = useAuth();
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [openViewDepartments, setOpenViewDepartments] = useState(false);
  const [sortValue, setSortValue] = useState("");
  const sortRef = useRef(null);
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const { school_id } = useSelector((state) => state.globalState);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
 const navigate = useNavigate();
   useEffect(() => {
     const handleResize = () => setIsMobile(window.innerWidth < 1024);
     window.addEventListener("resize", handleResize);
     return () => window.removeEventListener("resize", handleResize);
   }, []);

const sortOptions = [
  { label: "Name : A - Z", value: "A-Z" },
  { label: "Name : Z - A", value: "Z-A" },
  { label: "Newest First", value: "newest" },
  { label: "Oldest First", value: "oldest-first" },
];

useEffect(() => {
  const handleClickOutside = (e) => {
    if (sortRef.current && !sortRef.current.contains(e.target)) {
      setShowSortMenu(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

useEffect(() => {
  const timer = setTimeout(() => setDebouncedSearch(searchText), 400);
  return () => clearTimeout(timer);
}, [searchText]);

useEffect(() => {
  setCurrentPage(1);
}, [sortValue, debouncedSearch]);

useEffect(() => {
  if (!subjectId) return;
  
  dispatch(viewDepartmentAction(subjectId, token, sortValue || undefined ,
    {
    page: currentPage,
    search: debouncedSearch || undefined,  // move search to API too
    school_id:school_id
  }
  ));
}, [subjectId, sortValue, currentPage, debouncedSearch, school_id]);

  const { departmentDetails, loading, totalCount  } = useSelector(
    (state) => state.departmentData,
  );

  const departmentData =(Array.isArray(departmentDetails) ? departmentDetails : []).map((dept, index) => ({
    key:  dept.teacher_id ?? index + 1,
    teacherName: dept.teacher_name,
    teacherId: dept.teacher_id,
    avatar: dept.ai_avatar || null,
    departmentCourses:dept.department_courses,
    subject_name: dept.subject_name,
    role: dept.role,
    emailId: dept.email,
    assignedOn: dept.teachers_join_date,
  }));
  
 const handleModalClose = () => {
  setOpen(false);
  if (subjectId) {
    dispatch(viewDepartmentAction(subjectId, token, sortValue || undefined, {
      page: currentPage,
      search: debouncedSearch || undefined,
      school_id: school_id
    }));
  }
};
const filteredData = departmentData.filter((item) =>
  item.teacherName.toLowerCase().includes(searchText.toLowerCase()) ||
  item.emailId.toLowerCase().includes(searchText.toLowerCase())
);

const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  const [day, month, year] = dateStr.split("-");
  const date = new Date(`${year}-${month}-${day}`);
  const formattedDay = date.toLocaleString("en-GB", { day: "2-digit" });
  const formattedMonth = date.toLocaleString("en-GB", { month: "short" });
  const formattedYear = date.getFullYear();
  return `${formattedDay} ${formattedMonth}, ${formattedYear}`;
};
  // Columns
  const columns = [
    {
      key: "teacherName",
      title: "Teacher Name",
      render: (value, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {row.avatar ? (
            <img
              src={row.avatar}
              alt={value}
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                objectFit: "cover",
                flexShrink: 0,
              }}
            />
          ) : (
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#e2e8f0",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                color: "#94a3b8",
                fontWeight: 600,
              }}
            >
              {value?.charAt(0)}
            </div>
          )}
          <span>{value}</span>
        </div>
      ),
    },
    {
      key: "role",
      title: "Role",
      headerStyle: { textAlign: "center" },
      render: (value) => {
        const styles = {
          "advisor": { background: "#E6FFE5", color: "#28991F", textTransform:"capitalize" },
          "teacher": { background: "#EBF3FF", color: "#0068FF",  textTransform:"capitalize"  },
          "learning specialist": { background: "#ECCCFF", color: "#9803F2" , textTransform:"capitalize" },
          "hod": { background: "#FFECD6", color: "#FF8A00", textTransform:"uppercase"  },
        };

        const style = styles[value] || {
          background: "#f1f5f9",
          color: "#64748b",
        };

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
          <span
            style={{
              background: style.background,
              color: style.color,
              textTransform: style.textTransform,
              padding: "4px 12px",
              borderRadius: 999,
              fontSize: 12.5,
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            {value}
          </span>
        </div>
        );
      },
    },
    {
      key: "departmentCourses",
      title: "Department Courses",
      headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ),
    },
    {
      key: "emailId",
      title: "Email Id",
    },
    {
      key: "assignedOn",
      title: "Joined On",
      render: (value) => formatDate(value),
        headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ),
    },
     {
        key: "action",
        title: "Action",
        headerStyle: { textAlign: "center" },
        render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center",justifyContent:"center" }}>
          <span
             onClick={() => navigate(`/teacher/${row.teacherId}`, {
              state: {
                from: "/dashboard/departments",
                subjectId: subjectId,
                subjectName: subjectName,
              },
            })}     
            style={{
              color: "#0068FF",
              fontSize: 13.5,
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            View Profile
          </span>
          </div>
        ),
      },
  ];


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

const hodTeacher = Array.isArray(departmentDetails) 
  ? departmentDetails.find((t) => t.role === "hod") 
  : null;
  const existingHod = hodTeacher?.teacher_id ?? null;

  const total = filteredData.length === 0 ? 0 : (totalCount ?? 0);

  return (
    <>
      <div>
        <>
          <BackButton buttonName="Back" handleClick={navigateBack} />

          {/* Toolbar */}
          <div className="department-toolbar">
            <div className="department-left-tools">
              <h3 className="w-full">{subjectName}</h3>
              {/* Search */}
              <SearchComponent
                search={search_bar}
                searchPlaceholder="Search Teacher"
                value={searchText}
                onchange={(e) => setSearchText(e.target.value)}
              />
            {/*   <div className="search-bar">
                <img src={search_bar} alt="search-bar" />
                <div className="search-divider"></div>
                <input
                  placeholder="Search Teachers"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div> */}
            </div>

            <div className="department-right-tools">
              {/* Sort button */}
              <div style={{ position: "relative" }} ref={sortRef}>
                  <button className="sort-button" onClick={() => setShowSortMenu((prev) => !prev)}>
                    <img src={sort} alt="sort" />
                    Sort
                  </button>

                  {showSortMenu && (
                    <div className="sort-menu">
                      {sortOptions.map((option) => (
                        <div className="sort-options"
                          key={option.value}
                          onClick={() => { setSortValue(option.value); setShowSortMenu(false); }}
                          style={{
                            color: sortValue === option.value ? "#0068FF" : "#374151",
                            fontWeight: sortValue === option.value ? 600 : 400,
                            background: sortValue === option.value ? "#f0f7ff" : "#fff",
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                          onMouseLeave={(e) => e.currentTarget.style.background = sortValue === option.value ? "#f0f7ff" : "#fff"}
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              <button
                className="assign-hod-button"
                onClick={() => handleOpen()}
              >
                 {existingHod ? (
                      <>
                        <EditOutlinedIcon style={{ marginRight: 6 }} />
                        Edit HOD
                      </>
                    ) : (
                      "+ Assign HOD"
                    )}
              </button>
            </div>
          </div>

          {/* DataTable */}
          <div>
            {isMobile ? (
              <EnrollmentResponsiveCards
                data={filteredData.map((item) => ({
                  id: item.teacher_id,
                  name: item.teacherName,
                  email: item.emailId,
                  profilePic: item.avatar,
                  role: item.role,
                  departmentCourses: item.departmentCourses,
                  joinDate: formatDate(item.assignedOn)
                }))}
                styles={{
                  advisor: {
                    background: "#E6FFE5",
                    color: "#28991F",
                    textTransform: "capitalize",
                  },
                  teacher: {
                    background: "#EBF3FF",
                    color: "#0068FF",
                    textTransform: "capitalize",
                  },
                  "learning specialist": {
                    background: "#ECCCFF",
                    color: "#9803F2",
                    textTransform: "capitalize",
                  },
                  hod: {
                    background: "#FFECD6",
                    color: "#FF8A00",
                    textTransform: "uppercase",
                  },
                }}
                userType={"department"}
                onCardClick={(item) => navigate(`/teacher/${item.id}`, {
                  state: {
                    from: "/dashboard/departments",
                    subjectId: subjectId,
                    subjectName: subjectName,
                  },
                })}
              />
            ) : (
              <DataTableListing
                columns={columns}
                dataSource={filteredData ?? []}
                rowKey="key"
                pagination={
                  total > 12
                    ? {
                        currentPage: currentPage,
                        total: total,
                        pageSize: 12,
                        onChange: (page) => setCurrentPage(page),
                      }
                    : false
                }
                checkable={false}
                loading={loading}
                emptyText="No Teacher found"
                bordered={false}
                size="default"
                rowHoverColor="#F7F7F7"
              />
            )}
          </div>
        </>
      </div>

      <AccessRoleModal
        open={open}
        onClose={handleModalClose}
        mode="hod"
        subject_id={subjectId}
        existingHod={existingHod}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      ></AccessRoleModal>
    </>
  );
}

export default ViewDepartment;
